import ReportIcon from '@mui/icons-material/Report';
import * as theme from '../../theme';

export default function NotAuthorized() {
  return (
    <div style={{ ...theme.Container.basic, ...theme.Container.centeredViewport, color: theme.Colors.White }}>
      <div style={theme.PaddedContainer}>
        <div style={{ ...theme.Heading, ...theme.Center, marginBottom: 30, fontSize: 36 }}>Error! Not Authorized</div>
        <div style={{ marginBottom: 26, textAlign: 'center', width: '100%' }}><ReportIcon color={'primary'} sx={{ fontSize: 70 }} /></div>
        <div style={{ ...theme.SubHeading2, ...theme.Center }}>
        You do not have permissions to access the page you are trying to reach.
        </div>
      </div>
    </div>
  );
}